var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "YdDialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.showVisible,
        "append-to-body": "",
        width: "60%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.showVisible = $event
        },
        close: _vm.closeEdit,
        open: _vm.openEdit,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticStyle: { "margin-left": "30px", "margin-right": "10px" },
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            size: "mini",
            "label-position": "left",
            "label-width": "100px",
          },
        },
        [
          _c("div", { staticClass: "title-box" }, [_vm._v("基本信息")]),
          _c(
            "el-form-item",
            { attrs: { label: "活动名称", prop: "name" } },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: {
                  type: "text",
                  placeholder: "不超过10个字",
                  maxlength: "10",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "隶属公司", prop: "merchantId" } },
            [
              _c("YdMerchantSelector", {
                attrs: {
                  styles: "width: 300px",
                  placeholder: "请选择隶属公司",
                },
                model: {
                  value: _vm.form.merchantId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "merchantId", $$v)
                  },
                  expression: "form.merchantId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动时间", required: "" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "200px" },
                attrs: {
                  format: "yyyy-MM-dd HH:mm:ss",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "date",
                  placeholder: "开始日期",
                  "picker-options": _vm.pickerOptions1,
                },
                on: {
                  change: function ($event) {
                    return _vm.activeChange($event, "start")
                  },
                },
                model: {
                  value: _vm.form.startTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "startTime", $$v)
                  },
                  expression: "form.startTime",
                },
              }),
              _c("span", [_vm._v(" - ")]),
              _c("el-date-picker", {
                staticStyle: { width: "200px" },
                attrs: {
                  format: "yyyy-MM-dd HH:mm:ss",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "date",
                  placeholder: "结束日期",
                  "picker-options": _vm.pickerOptions1,
                },
                on: {
                  change: function ($event) {
                    return _vm.activeChange($event, "end")
                  },
                },
                model: {
                  value: _vm.form.endTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "endTime", $$v)
                  },
                  expression: "form.endTime",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "抢购时间" } },
            [
              _vm.form.time && _vm.form.time.length
                ? _c(
                    "el-row",
                    _vm._l(_vm.form.time, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass:
                            "margin-bottom-10 flex flex-align-center",
                        },
                        [
                          _c("el-time-picker", {
                            attrs: {
                              format: "HH:mm",
                              "value-format": "HH:mm",
                              "picker-options": {
                                selectableRange: _vm.testSelectableRange,
                              },
                              placeholder: "请选择时",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.timeChange(index)
                              },
                            },
                            model: {
                              value: item.startTime,
                              callback: function ($$v) {
                                _vm.$set(item, "startTime", $$v)
                              },
                              expression: "item.startTime",
                            },
                          }),
                          _c("span", { staticClass: "margin-x-5" }, [
                            _vm._v(" - "),
                          ]),
                          _c("el-time-picker", {
                            attrs: {
                              format: "HH:mm",
                              "value-format": "HH:mm",
                              "picker-options": {
                                selectableRange: _vm.testSelectableRange,
                              },
                              placeholder: "请选择分",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.timeChange(index)
                              },
                            },
                            model: {
                              value: item.endTime,
                              callback: function ($$v) {
                                _vm.$set(item, "endTime", $$v)
                              },
                              expression: "item.endTime",
                            },
                          }),
                          index !== 0
                            ? _c("i", {
                                staticClass: "el-icon-remove margin-left-10",
                                staticStyle: { "font-size": "20px" },
                                on: {
                                  click: function ($event) {
                                    return _vm.controlsTime("del", index)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _c("el-row", [
                _c("i", {
                  staticClass: "el-icon-circle-plus",
                  staticStyle: { "font-size": "25px" },
                  on: {
                    click: function ($event) {
                      return _vm.controlsTime("add")
                    },
                  },
                }),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "title-box" }, [_vm._v("乘客端展示")]),
          _c(
            "el-form-item",
            { attrs: { label: "活动头图", prop: "headImgUrl", required: "" } },
            [
              _c(
                "el-upload",
                {
                  ref: "uploadRef",
                  class: { disabled: _vm.uploadDisabled },
                  staticStyle: { width: "100%" },
                  attrs: {
                    action: _vm.doUpload,
                    headers: _vm.headers,
                    name: "file",
                    "list-type": "picture-card",
                    "before-upload": function (file) {
                      return _vm.handleBeforeUpload(file, 750, 432)
                    },
                    "on-success": function (response, file, fileList) {
                      return _vm.uploadSuccess(response, file, fileList)
                    },
                    "on-error": _vm.handleUploadError,
                    "on-remove": _vm.handleRemove,
                    "file-list": _vm.fileList,
                    "show-file-list": true,
                    data: { code: "activity" },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip",
                    },
                    [_vm._v("jpg/png格式，宽度750，高度432，不超过500kb。")]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动背景色", prop: "backcolor" } },
            [
              _c("el-color-picker", {
                staticStyle: { width: "100px" },
                model: {
                  value: _vm.form.backcolor,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "backcolor", $$v)
                  },
                  expression: "form.backcolor",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: " 活动规则", prop: "rule" } },
            [
              _c("rich-text-editor", {
                model: {
                  value: _vm.form.rule,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "rule", $$v)
                  },
                  expression: "form.rule",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
              },
            },
            [
              _c("div", { staticClass: "title-box" }, [_vm._v("活动奖励")]),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-circle-plus-outline",
                    size: "mini",
                  },
                  on: { click: _vm.handleAddCoupon },
                },
                [_vm._v("添加优惠券")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "padding-top": "10px" } },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.couponItem,
                    border: "",
                    size: "mini",
                    "max-height": "280px",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "序号",
                      type: "index",
                      width: "50",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "优惠券名称",
                      align: "center",
                      prop: "name",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "所属礼包",
                      align: "center",
                      prop: "giftName",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "金额/个",
                      align: "center",
                      prop: "discountsMoney",
                      width: "80",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "剩余数量",
                      align: "center",
                      prop: "surplusNum",
                      width: "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "每次领取数量",
                      align: "center",
                      prop: "num",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("avue-input-number", {
                              staticStyle: { width: "8vw" },
                              attrs: { "min-rows": "0" },
                              model: {
                                value: scope.row.num,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "num", $$v)
                                },
                                expression: "scope.row.num",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "每日限量", align: "center", prop: "num" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("avue-input-number", {
                              staticStyle: { width: "8vw" },
                              attrs: { "min-rows": "0" },
                              model: {
                                value: scope.row.dayNum,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "dayNum", $$v)
                                },
                                expression: "scope.row.dayNum",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deletes(scope.$index)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "margin-top-10",
              attrs: { label: "每人限领", prop: "everyPersonTime" },
            },
            [
              _c("el-input-number", {
                staticStyle: { width: "80px" },
                attrs: {
                  size: "mini",
                  placeholder: "请输入",
                  controls: false,
                  precision: 0,
                  min: 1,
                },
                model: {
                  value: _vm.form.everyPersonTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "everyPersonTime", $$v)
                  },
                  expression: "form.everyPersonTime",
                },
              }),
              _vm._v("\n      次\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.closeEdit } }, [_vm._v("取 消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
      _vm.selectVisible
        ? _c("select-coupon", {
            ref: "selectCoupon",
            attrs: { disable: true },
            on: { getCouponItem: _vm.getCouponItem },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }